import { render, staticRenderFns } from "./addMark.vue?vue&type=template&id=43b785e0&"
import script from "./addMark.vue?vue&type=script&lang=js&"
export * from "./addMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports